// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-footer[data-v-32073ce8] {\n  background-color: var(--carbon-100) !important;\n}\n", ""]);
// Exports
module.exports = exports;
